export default __webpack_public_path__ + "static/media/topDecorations.587dfd43.png";